const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}/${month}/${day} . ${hours}:${minutes}`;
};

export const transformDataToArray = (data) => {
  const resultMap = new Map();

  for (const [pairKey, timeframes] of Object.entries(data)) {
    for (const [timeframeKey, details] of Object.entries(timeframes)) {
      const { pair, break_count, break_points } = details;


      // Create a unique key for each pair and timeframe
      const key = `${pairKey}-${timeframeKey}`;

      // Initialize the entry if it doesn't exist
         if (!resultMap.has(key)) {
            resultMap.set(key, {
                pair: { ...pair }, // Spread the pair object to include all its properties
                timeframe: timeframeKey,
                breakCount: break_count,
                upperPoints: [],
                lowerPoints: [],
            });
        }

      // Aggregate upper and lower points for both break types
      const entry = resultMap.get(key);

      const { lower, upper } = break_points;

      // Format and add upper points
      if (upper && upper.length > 0) {
        entry.upperPoints.push(...upper.map(formatDate));
      }

      // Format and add lower points
      if (lower && lower.length > 0) {
        entry.lowerPoints.push(...lower.map(formatDate));
      }
    }
  }

  // Convert the map to an array
  return Array.from(resultMap.values());
};
